// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3FIFm","list":"BalanceDue_list__2mOLA","listRow":"BalanceDue_listRow__2ejnr","total":"BalanceDue_total__2vusD"};